//=================================================================================================
// SCRIPTING
//=================================================================================================

<script>
import Vue          from 'vue';
import Component    from 'vue-class-component';
import ExternalLink from '@/components/ExternalLink';

const EXT_LINK_WIKI      = 'https://tropicaltowerwars.fandom.com';
const EXT_LINK_SIGNUPS   = 'https://surrealms.studio/early-access';
const EXT_LINK_INSTAGRAM = 'https://www.instagram.com/tropicaltowerwars';
const EXT_LINK_KOFI      = 'https://ko-fi.com/tropicaltowerwars';
const EXT_LINK_DISCORD   = 'https://discord.gg/ap7Xzrj';
const ROTATION_FACTOR    = 1.8;

@Component({
	props      : {
		offset : Boolean,
	},
	components : {
		ExternalLink,
	},
	watch      : {
		'$route' : 'onNavigate',
	},
})
export default class NavBar extends Vue {
	// Constants passthrough
	//--------------------------------------------------------------------------------------------------

	EXT_LINK_WIKI      = EXT_LINK_WIKI;
	EXT_LINK_SIGNUPS   = EXT_LINK_SIGNUPS;
	EXT_LINK_INSTAGRAM = EXT_LINK_INSTAGRAM;
	EXT_LINK_KOFI      = EXT_LINK_KOFI;
	EXT_LINK_DISCORD   = EXT_LINK_DISCORD;

	sticky         = false;
	rotation       = 0;
	showMobileMenu = false;

	mounted () {
		this.rotation = 0;

		window.addEventListener('scroll', this.onScroll.bind(this));
	}

	onScroll () {
		const distance = window.pageYOffset - this.$el.offsetTop;

		this.sticky   = (distance > 0);
		this.rotation = Math.max(0, distance) * ROTATION_FACTOR;
	}

	onToggleMobileMenu () {
		this.showMobileMenu = !this.showMobileMenu;
	}

	onNavigate () {
		this.showMobileMenu = false;
	}
}
</script>

//=================================================================================================
// TEMPLATING
//=================================================================================================

<template>
<div class="navbar-root" :class="{ offset }">

	<div class="navbar-container" :class="{ sticky: sticky || !offset }">
		<nav class="navbar">
			<!-- Mobile menu -->
			<div :class="{ hidden: !showMobileMenu }" class="sm-l menu-mobile">
				<!-- Main links -->
				<router-link :to="{ name: 'News' }" class="navbar-item f--no-react">News</router-link>
				• <router-link :to="{ name: 'Mazes' }" class="navbar-item f--no-react">Mazes</router-link>
				• <ExternalLink :href="EXT_LINK_SIGNUPS" class="navbar-item f--no-react" :shown="true">Alpha Signups <mark>New</mark></ExternalLink>
				<!-- • <ExternalLink :href="EXT_LINK_WIKI" :shown="true" class="navbar-item f--no-react">Wiki</ExternalLink> -->

				<!-- Icon links -->
				<ExternalLink :href="EXT_LINK_DISCORD" class="navbar-item icon">
					<img src="@/assets/images/icons/discord-64x64.png" />
				</ExternalLink>
				<ExternalLink :href="EXT_LINK_INSTAGRAM" class="navbar-item icon">
					<img src="@/assets/images/icons/instagram-64x64.png" />
				</ExternalLink>
				<ExternalLink :href="EXT_LINK_KOFI" class="navbar-item icon">
					<img src="@/assets/images/icons/kofi-64x64.png" />
				</ExternalLink>
			</div>

			<!-- Gear visuals -->
			<img
				:style = "{ transform: `rotate(${+rotation}deg)`}"
				class  = "gear bottom left"
				src    = "@/assets/images/gear.png"
			/>

			<img
				:style = "{ transform: `rotate(${-rotation}deg)`}"
				class  = "gear bottom right"
				src    = "@/assets/images/gear.png"
			/>

			<!-- Full menu -->
			<div class="navbar-background">
				<div class="navbar-content r--content">
					<!-- Desktop home & partial links -->
					<div class="md-g navbar-wing">
						<router-link :to="{ name: 'Home' }">
							<img class="mini-logo" src="@/assets/images/logo mini.svg" />
						</router-link>

						<div class="g--stretch"></div>

						<router-link class="navbar-item text" :to="{ name: 'News' }">News</router-link>
						• <router-link class="navbar-item text" :to="{ name: 'Mazes' }">Mazes</router-link>
					</div>

					<!-- Mobile home button -->
					<div class="sm-l navbar-wing">
						<router-link :to="{ name: 'Home' }">
							<img class="mini-logo" src="@/assets/images/logo mini.svg" />
						</router-link>

						<div class="g--stretch"></div>
					</div>

					<!-- Play button -->
					<router-link class="s--button-box f--unlined" :to="{ name: 'Downloads' }">
						<div class="s--button">Play For Free</div>
					</router-link>

					<!-- Desktop partial links and icon links -->
					<div class="md-g navbar-wing">
						<ExternalLink :href="EXT_LINK_SIGNUPS" class="navbar-item text" :shown="true">
							Alpha Signups <mark>New</mark>
						</ExternalLink>
						<!-- • <ExternalLink :href="EXT_LINK_WIKI" :shown="true" class="navbar-item text">Wiki</ExternalLink> -->

						<div class="g--stretch"></div>

						<ExternalLink :href="EXT_LINK_DISCORD" class="navbar-item icon">
							<img src="@/assets/images/icons/discord-64x64.png" />
						</ExternalLink>
						<ExternalLink :href="EXT_LINK_INSTAGRAM" class="navbar-item icon">
							<img src="@/assets/images/icons/instagram-64x64.png" />
						</ExternalLink>
						<ExternalLink :href="EXT_LINK_KOFI" class="navbar-item icon">
							<img src="@/assets/images/icons/kofi-64x64.png" />
						</ExternalLink>
					</div>

					<!-- Mobile menu toggle -->
					<div class="sm-l navbar-wing">
						<div class="g--stretch"></div>

						<span @click="onToggleMobileMenu()" class="g--clickable">
							<FontAwesomeIcon size="lg" :icon="showMobileMenu ? 'angle-double-up' : 'bars'" />
						</span>
					</div>
				</div>
			</div>
		</nav>
	</div>
</div>
</template>

//=================================================================================================
// STYLING
//=================================================================================================

<style lang="scss" scoped>
@import '../assets/scss/colour.scss';

.navbar-root {
	z-index                     : 1000;
	position                    : absolute;
	top                         : 0;
	width                       : 100%;
	overflow                    : hidden;
	pointer-events              : none;

	&.offset {
		top                         : calc(100vh - 120px);
	}
}

.navbar {
	height                      : 50px;
	margin-bottom               : 80px;
}

.navbar-background {
	width                       : 100%;
	height                      : 100%;
	background-image            : url('../assets/images/plank.png');
	background-repeat           : repeat-x;
	background-size             : auto 100%;
	background-position         : center;
	filter                      : drop-shadow(2px 2px 5px #000000);
	pointer-events              : all;
}

.navbar-container {
	position                    : relative;
	width                       : 100%;
	padding                     : 5px 0;

	&.sticky {
		position                    : fixed;
		top                         : 0;
	}
}

.navbar-content {
	height                      : 100%;
	display                     : flex;
	align-items                 : center;
	font-size                   : 2.0rem; // TODO: Move to text.scss
	color                       : white;
}

.navbar-wing {
	display                     : flex;
	flex                        : 1 0 0;
	align-items                 : center;
}

.navbar-item {
	margin                      : 0 8px;
	color                       : white;
	text-shadow                 : 0 0 5px black;
	text-align                  : center;
	font-family                 : ff--heading;
	letter-spacing              : 1px;
	text-decoration             : none;

	&.icon {
		position                    : relative;
		display                     : flex;
		align-items                 : center;
		justify-content             : center;
		width                       : 20px;
		height                      : 20px;
		margin                      : 0 4px;
		padding                     : 4px;
		border-radius               : 0.2rem;
		background-color            : #FFFFFF;
		box-shadow                  : 0 0 2px white;

		& > img {
			display                     : block;
			width                       : 100%;
		}
	}

	// TEMP: Should use font.scss instead
	&.text {
		margin-bottom               : -6px;
	}
}

.mini-logo {
	width                       : 26px;
	height                      : 26px;
	transition                  : filter 0.5s;
	filter                      : drop-shadow(0 0 5px black);
}

.gear {
	position                    : absolute;
	width                       : 20px;
	height                      : 20px;
	filter                      : drop-shadow(-1px -1px 2px #000000);

	&.top    { top    : -2px; }
	&.bottom { bottom : 78px; }
	&.left   { left   : -5px; }
	&.right  { right  : -5px; }
}

.menu-mobile {
	position                    : absolute;
	top                         : 0;
	left                        : 0;
	right                       : 0;
	padding                     : 10px 0;
	display                     : flex;
	align-items                 : center;
	justify-content             : center;
	color                       : white;
	opacity                     : 1.0;
	transition-property         : opacity, transform;
	transition-duration         : 0.5s;
	transform                   : translateY(48px);
	background-image            : url('../assets/images/plank.png');
	background-repeat           : repeat-x;
	background-size             : auto 100%;
	background-position         : right 10% center;
	pointer-events              : all;

	&.hidden {
		transform                   : translateY(0px);
		opacity                     : 0.0;
	}

	& > .navbar-item.icon {
		width                       : 20px;
		height                      : 20px;
		// Slightly reposition so looks good with the text
		margin-bottom               : 2px;
		margin-top                  : -2px;
	}
}
</style>
